import { pxToRem } from 'src/theme'
import styled, { css } from 'styled-components'

export const Label = styled.label<{
  $error?: boolean
  $required?: boolean
}>`
  ${(props) => props.theme.textStyles.m375_bodySmall}
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.black};
  margin-bottom: ${pxToRem(16)};
  display: inline-block;
  position: relative;
  align-self: flex-start;

  ${(props) =>
    props.$error &&
    css`
      color: ${(props) => props.theme.colors.error};
    `}

  ${(props) =>
    props.$required &&
    css`
      &::after {
        content: '*';
        display: inline-block;
        ${(props) => props.theme.textStyles.m375_bodySmall}
        color: ${(props) => props.theme.colors.error};
      }
    `}
`
